module.exports = __webpack_public_path__ + "img/329.05cc1808.jpg";